export default __webpack_public_path__ + "static/media/aarde.efd03025.png";